/* eslint-disable import/prefer-default-export */
import { Routes } from '../constants/routes'
//import { ResourceTypeEnum } from '../endpoints/services/commonHdr.service'

export interface TileData {
  typeTile?: 'advanced' | 'basic'
  selectorId?: string
  title: string
  route?: () => string
  tooltip?: string
}

export const Tiles: { [key: string]: TileData } = {
  objects: {
    title: 'Objects',
    route: () => Routes?.pages?.objects?.path
  },
  roles: {
    title: 'Roles'
  },
  users: {
    title: 'Users',
    route: () => Routes?.pages?.identities?.path,
    tooltip: `Count of human identities who have access to log in to your
       cloud platform. Includes AWS IAM users, Azure AD users, and
       G-Suite users. Non-human access such as service accounts and
       bots are not included. Inactive users have not logged in
       within the last 90 days.`
  },
  privileges: {
    title: 'Privileges',
    route: () => Routes?.pages?.privileges?.path,
    tooltip: `Count of privileges assigned across all active users.
       Privileges are individual permissions or entitlements on cloud
       objects to perform an action, such as the ability to create,
       delete, read, etc. Inactive privileges are assigned to an active
       user but not used within the last 90 days.`
  },
  violations: {
    title: 'Violations'
  },
  members: {
    title: 'Members'
  },

  accounts: {
    title: 'Sources',
    route: () => Routes?.pages?.sources?.path,
    tooltip: `Count of all known AWS Accounts, Azure Subscriptions, and Google
       Projects in your cloud platform environment.`
  },
  alerts: {
    title: 'Alerts'
  },
  changes: {
    title: 'Changes'
  },
  guardrails: {
    title: 'Guardrails'
  },
  iam: {
    title: 'IAM'
  },
  auditTrail: {
    title: 'Audit Trail'
  },
  networking: {
    title: 'Networking'
  },
  unusedSensitivePrivs: {
    typeTile: 'advanced',
    selectorId: 'UnusedSensitivePrivileges',
    route: () => Routes?.pages?.unusedSAccess?.path,
    title: 'Unused Access',
    tooltip: `Count of all of the sensitive access that has not been used for
       the past 90 days divided by roles, identities, and direct IAM user access
       without roles. This includes unused access provided by services as
       well.`
  }
}
